<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (firstChoiceValue != secondChoiceValue) {
          @if (index == 0) {
            <ng-container [formGroup]="product">
              <ng-container formGroupName="parameters">
                <div class="row">
                  <div class="col-md-12 mt">
                    <pr-input-radio-round
                      formControlName="finalDateMission"
                      label="Date(s) de fin d'exercice possible(s)"
                      [derrors]="derrors"
                      [options]="[
                        {
                          value: firstChoiceValue,
                          label: firstChoice,
                          checked: true,
                        },
                        { value: secondChoiceValue, label: secondChoice },
                      ]"
                    >
                    </pr-input-radio-round>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          }
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
